var map = {
	"./af.json": 833,
	"./am.json": 834,
	"./ar.json": 835,
	"./az.json": 836,
	"./be.json": 837,
	"./bg.json": 838,
	"./bn.json": 839,
	"./bs.json": 840,
	"./ca.json": 841,
	"./cs.json": 842,
	"./cy.json": 843,
	"./da.json": 844,
	"./de.json": 845,
	"./dv.json": 846,
	"./el.json": 847,
	"./en.json": 848,
	"./es.json": 849,
	"./et.json": 850,
	"./eu.json": 851,
	"./fa.json": 852,
	"./fi.json": 853,
	"./fr.json": 854,
	"./gl.json": 855,
	"./ha.json": 856,
	"./he.json": 857,
	"./hi.json": 858,
	"./hr.json": 859,
	"./hu.json": 860,
	"./hy.json": 861,
	"./id.json": 862,
	"./is.json": 863,
	"./it.json": 864,
	"./ja.json": 865,
	"./ka.json": 866,
	"./kk.json": 867,
	"./km.json": 868,
	"./ko.json": 869,
	"./ku.json": 870,
	"./ky.json": 871,
	"./lt.json": 872,
	"./lv.json": 873,
	"./mk.json": 874,
	"./ml.json": 875,
	"./mn.json": 876,
	"./ms.json": 877,
	"./nb.json": 878,
	"./nl.json": 879,
	"./nn.json": 880,
	"./no.json": 881,
	"./pl.json": 882,
	"./ps.json": 883,
	"./pt.json": 884,
	"./ro.json": 885,
	"./ru.json": 886,
	"./sd.json": 887,
	"./sk.json": 888,
	"./sl.json": 889,
	"./so.json": 890,
	"./sq.json": 891,
	"./sr.json": 892,
	"./sv.json": 893,
	"./sw.json": 894,
	"./ta.json": 895,
	"./tg.json": 896,
	"./th.json": 897,
	"./tr.json": 898,
	"./tt.json": 899,
	"./ug.json": 900,
	"./uk.json": 901,
	"./ur.json": 902,
	"./uz.json": 903,
	"./vi.json": 904,
	"./zh.json": 905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 832;